import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const multiSwitchSettingsFn = /* @__PURE__ */ createRecipe('multi-switch-settings', {}, [])

const multiSwitchSettingsVariantMap = {}

const multiSwitchSettingsVariantKeys = Object.keys(multiSwitchSettingsVariantMap)

export const multiSwitchSettings = /* @__PURE__ */ Object.assign(memo(multiSwitchSettingsFn.recipeFn), {
  __recipe__: true,
  __name__: 'multiSwitchSettings',
  __getCompoundVariantCss__: multiSwitchSettingsFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: multiSwitchSettingsVariantKeys,
  variantMap: multiSwitchSettingsVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, multiSwitchSettingsVariantKeys)
  },
  getVariantProps: multiSwitchSettingsFn.getVariantProps,
})